import { useEffect, useState } from 'react';
import { getPublicPage } from '../api/contentApi';
import { parseFooterContent } from '../utils/footerContent';
import { resolveMediaUrl } from '../utils/mediaUrl';
import { createContentCache } from '../utils/contentCache';

const withResolvedUrls = (content) => {
  if (!content) {
    return null;
  }

  return {
    ...content,
    logo: content.logo
      ? { ...content.logo, url: resolveMediaUrl(content.logo.url) }
      : null,
    logomark: content.logomark
      ? { ...content.logomark, url: resolveMediaUrl(content.logomark.url) }
      : null,
    socials: content.socials.map((social) => ({
      ...social,
      icon: resolveMediaUrl(social.icon),
    })),
  };
};

const footerCache = createContentCache();

export const useFooterContent = () => {
  const [content, setContent] = useState(() => footerCache.getCached());
  const [isLoading, setIsLoading] = useState(() => !footerCache.getCached());
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      try {
        const parsed = await footerCache.load(async () => {
          const page = await getPublicPage('global-layout');
          return withResolvedUrls(parseFooterContent(page));
        });

        if (!isMounted) {
          return;
        }

        setContent(parsed);
        setError(null);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setContent(null);
        setError(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  return { content, isLoading, error };
};
